import { connect } from 'react-redux';
import { withRouter } from "react-router";
import BlankFrame from '../../components/BlankFrame';

const mapState = ({auth: { user }}) => {
    return {
        user: user,
    };
};

export default connect(
mapState,
{},
)(withRouter(BlankFrame));
